/**
 * Свой шрифт воронки (слово владельца 20.10.2026) — ссылка на загруженное
 * семейство в поле `fontId` (у воронки и у блока): строка `custom:<семейство>`.
 *
 * Отдельный файл без зависимостей: его зовут и `fonts.ts` (`resolveFontPair`),
 * и `customFonts.ts` (правила `@font-face`, правка списка) — так между ними
 * нет круга импортов. Набор знаков имени — тот же, что у сервера
 * (`backend/src/ai-funnels/block-schema/custom-fonts.ts`, FAMILY_RE): буквы,
 * цифры, пробел, `_` и `-`, первым — буква или цифра, до 48 знаков. Кавычке,
 * скобке, точке с запятой в имени взяться неоткуда — имя идёт в CSS как есть.
 */
export const CUSTOM_FONT_PREFIX = 'custom:';

const FAMILY_RE = /^[\p{L}\p{N}][\p{L}\p{N} _-]{0,47}$/u;

export function isCustomFontFamily(value: unknown): value is string {
  return typeof value === 'string' && FAMILY_RE.test(value);
}

export function customFontRef(family: string): string {
  return `${CUSTOM_FONT_PREFIX}${family}`;
}

/** Семейство из ссылки `custom:<семейство>`; не ссылка или неверное имя — undefined. */
export function customFontFamilyOf(
  fontId: string | undefined,
): string | undefined {
  if (typeof fontId !== 'string' || !fontId.startsWith(CUSTOM_FONT_PREFIX))
    return undefined;
  const family = fontId.slice(CUSTOM_FONT_PREFIX.length);
  return isCustomFontFamily(family) ? family : undefined;
}
